import { DataFormAddBannerProps } from './index';
import { DynamicPageProps } from 'types/DynamicPageProps';
import { SelectInputItemProps } from 'types/SelectInputItemProps';

export function verifyIfFormCanSave(
	dataForm: DataFormAddBannerProps,
	withTitle: boolean,
	handleNotify: any,
	useDescription = false
) {
	if (
		useDescription &&
		dataForm.description &&
		dataForm.description.title === ''
	) {
		handleNotify('Preencha o título do banner', 'error');
		return false;
	}

	if (
		useDescription &&
		dataForm.description &&
		dataForm.description.subTitle === ''
	) {
		handleNotify('Preencha o subtítulo do banner', 'error');
		return false;
	}

	if (
		useDescription &&
		dataForm.description &&
		dataForm.description.descriptionText === ''
	) {
		handleNotify('Preencha a descrição do banner', 'error');
		return false;
	}

	if (withTitle && dataForm.title === '') {
		handleNotify('Preenha o campo "Título"', 'error');
		return false;
	}

	if (dataForm.redirectType === '') {
		handleNotify('Preencha o tipo do redirecionamento', 'error');
		return false;
	}

	if (dataForm.redirectValue === '') {
		handleNotify('Preencha o valor do redirecionameto', 'error');
		return false;
	}

	if (dataForm.banner === null) {
		handleNotify('Suba a imagem do banner', 'error');
		return false;
	}

	return true;
}

export function returListOptionsDynamicPage(
	listPages: DynamicPageProps[]
): SelectInputItemProps[] {
	const listOptions: SelectInputItemProps[] = [];

	listPages.forEach((item) => {
		listOptions.push({ id: item.id, option: item.name });
	});

	return listOptions;
}
